var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverTotalSeekers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 31.25C15.2614 31.25 17.5 29.0114 17.5 26.25C17.5 23.4886 15.2614 21.25 12.5 21.25C9.73858 21.25 7.5 23.4886 7.5 26.25C7.5 29.0114 9.73858 31.25 12.5 31.25Z",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15C15.2614 15 17.5 12.7614 17.5 10C17.5 7.23858 15.2614 5 12.5 5C9.73858 5 7.5 7.23858 7.5 10C7.5 12.7614 9.73858 15 12.5 15Z",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 31.25C30.2614 31.25 32.5 29.0114 32.5 26.25C32.5 23.4886 30.2614 21.25 27.5 21.25C24.7386 21.25 22.5 23.4886 22.5 26.25C22.5 29.0114 24.7386 31.25 27.5 31.25Z",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 35C5.87325 33.8357 7.0056 32.8906 8.30737 32.2397C9.60914 31.5889 11.0446 31.25 12.5 31.25C13.9554 31.25 15.3909 31.5889 16.6926 32.2397C17.9944 32.8906 19.1267 33.8357 20 35C20.8733 33.8357 22.0056 32.8906 23.3074 32.2397C24.6091 31.5889 26.0446 31.25 27.5 31.25C28.9554 31.25 30.3909 31.5889 31.6926 32.2397C32.9944 32.8906 34.1267 33.8357 35 35",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15C30.2614 15 32.5 12.7614 32.5 10C32.5 7.23858 30.2614 5 27.5 5C24.7386 5 22.5 7.23858 22.5 10C22.5 12.7614 24.7386 15 27.5 15Z",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18.75C5.87325 17.5857 7.0056 16.6406 8.30737 15.9897C9.60914 15.3389 11.0446 15 12.5 15C13.9554 15 15.3909 15.3389 16.6926 15.9897C17.9944 16.6406 19.1267 17.5857 20 18.75C20.8733 17.5857 22.0056 16.6406 23.3074 15.9897C24.6091 15.3389 26.0446 15 27.5 15C28.9554 15 30.3909 15.3389 31.6926 15.9897C32.9944 16.6406 34.1267 17.5857 35 18.75",
    stroke: "#1859B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverTotalSeekers);
export default __webpack_public_path__ + "static/media/hover-total-seekers.aceea8768e17ac79b722970889bb0aa7.svg";
export { ForwardRef as ReactComponent };